import React from "react";
import { useNavigate } from "react-router-dom";
import { API } from "../../config/api";
import "./../Styles/logout.css";

export default function Logout() {
  const navigate = useNavigate();

  /* ================= LOGOUT ================= */

  const handleLogout = async () => {
    try {
      await fetch(API.LOGOUT, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        credentials: "include",
      });
    } catch (err) {
      console.error("Logout API Error:", err);
    }

    // ✅ STEP 1: clear storage FIRST
    sessionStorage.removeItem("user");
    localStorage.removeItem("user");

    window.dispatchEvent(new Event("userLogout"));

    // ✅ STEP 2: redirect safely
    navigate("/", { replace: true });
  };

  /* ================= CANCEL ================= */

  const handleCancel = () => {
    const user = JSON.parse(sessionStorage.getItem("user"));

    if (!user) {
      navigate("/");
      return;
    }

    if (user.role === "admin") {
      navigate("/admin/dashboard");
    } else {
      navigate("/user/dashboard");
    }
  };

  return (
    <div className="logout-overlay" onClick={handleCancel}>
      <div className="logout-popup" onClick={(e) => e.stopPropagation()}>
        <div className="logout-icon">
          <i className="bi bi-box-arrow-right"></i>
        </div>

        <h3>Are you sure you want to logout?</h3>

        <p>
          You will be logged out of your account and redirected to login page.
        </p>

        <div className="logout-actions">
          <button className="logout-confirm" onClick={handleLogout}>
            Yes, Logout
          </button>

          <button className="logout-cancel" onClick={handleCancel}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
}
